import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Story } from './components/Story';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { PricingCards } from './components/PricingCards';
import { HowToUse } from './components/HowToUse';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { Navigation } from './components/Navigation';
import { DetailedTestimonials } from './components/DetailedTestimonials';
export function App() {
  useEffect(() => {
    // Create and inject the script
    const script = document.createElement('script');
    script.innerHTML = `
      !(function (e, n, t, i, p, a, s) {
        e[i] ||
          (((p = e[i] =
            function () {
              p.process ? p.process.apply(p, arguments) : p.queue.push(arguments);
            }).queue = []),
          (p.t = +new Date()),
          ((a = n.createElement(t)).async = 1),
          (a.src = 'https://static.newsbreak.com/business/tracking/nbpixel.js?t=' + 864e5 * Math.ceil(new Date() / 864e5)),
          (s = n.getElementsByTagName(t)[0]).parentNode.insertBefore(a, s));
      })(window, document, 'script', 'nbpix'),
        nbpix('init', 'ID-1937330171240284162'),
        nbpix('event', 'pageload');
    `;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <div className="w-full bg-white" data-id="element-0">
      <Navigation data-id="element-1" />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <Header data-id="element-3" />
        <Story data-id="element-4" />
        <Benefits data-id="element-5" />
        <DetailedTestimonials data-id="element-6" />
        <Testimonials data-id="element-7" />
        <PricingCards data-id="element-8" />
        <HowToUse data-id="element-9" />
        <FAQ data-id="element-10" />
        <Footer data-id="element-11" />
      </div>
    </div>;
}